// extracted by mini-css-extract-plugin
export default {"container":"Crm_container__z0IE4"};